import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import Modal from 'react-bootstrap/Modal';
import { Login } from "../Components/Login/Login";
import { NavLink, } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import { useSelector, useDispatch } from "react-redux";
import { addWishlist, clearWishlist, removeWishlist } from "../redux/Slices/cartSlice";
import { LoginModal } from "./LoginModal/LoginModal";

const WishlistIcon = (props) => {
    let { productId } = props;
    let { setIsDeleted } = props;
    let { Setlogin, LoginAccount } = props
    // console.log(props)

    const dispatch = useDispatch();
    const { cart } = useSelector((state) => state);
    let userId = localStorage.getItem("userId") || localStorage.getItem("userid");
    const [WishId, setWishId] = useState(false);
    const [loginShow, setLoginShow] = useState(false);
    const handleLoginShow = () => setLoginShow(true);

    const isRent = localStorage.getItem("listingType") === "rent";
    const expectedType = isRent ? "rental" : "sale";

    const addToWishlist = (id) => {
        if (!localStorage.getItem("token")) {
            setLoginShow(true);
            return;
        }

        axiosConfig.post(`/catlog/wishlists/`, { user: userId, varient: id, type: expectedType })
            .then(res => {
                dispatch(addWishlist({
                    productId: id,
                    wish_id: res.data.id,
                    type: expectedType
                }));
            });
    };

    const removeFromWishlist = () => {
        const item = (cart?.wishlists || []).find(p => p.id === productId && p.type === expectedType);
        if (!item?.wish_id) return;

        axiosConfig.delete(`/catlog/wishlists/${item.wish_id}/`)
            .then(() => {
                dispatch(removeWishlist({ productId, type: expectedType }));
                if (typeof setIsDeleted === 'function') {
                    setIsDeleted(true);
                }
            });
    };

    return (
        <div className="icon-wishlist">
            {(cart?.wishlists || []).some((p) => p.id === productId && p.type === expectedType) ? (
                <AiFillHeart onClick={() => removeFromWishlist()} />
            ) : (
                <AiOutlineHeart onClick={userId ? () => addToWishlist(productId) : handleLoginShow} />
            )}
            {loginShow &&
                <LoginModal setLoginType={setLoginShow} LoginType={loginShow} setLoggedIn={Setlogin} LoggedIn={LoginAccount} />
            }
        </div>
    )
}
export default WishlistIcon
